import * as React from "react"
import "./ready.css"
import dummy from "../../../images/dummy.png"
import {Link} from "gatsby"

import agri from "../../../images/products/cover/agri.jpg"
import fab from "../../../images/products/cover/fab.jpg"
import hospitality from "../../../images/products/cover/hospitality.jpg"
import med from "../../../images/products/cover/med.jpg"
import pack from "../../../images/products/cover/pack.jpg"
import safe from "../../../images/products/cover/safe.jpg"


const Ready = () => {
    return (
        <section className="wrapper bg-light" id={`products`}>
            <div className="container col-8 py-8 py-md-11">
                <div className="grid grid-view projects-masonry text-center">
                    <div className="row gx-md-8 gy-10 gy-md-13">
                        <div
                            className="project item col-md-12 col-xl-12 product d-flex justify-content-center align-items-center">
                            <div className="col-lg-9 col-xl-8 col-xxl-7 mx-auto">
                                <h2 className="fs-16 text-uppercase text-pink mb-3">
                                    Our Products
                                </h2>
                                <h3 className="display-4">
                                    Check out some of our awesome products with great
                                    design.
                                </h3>
                            </div>
                        </div>
                        <div
                            key={1}
                            data-sal="flip-up"
                            data-sal-delay="100"
                            data-sal-easing="easeInExpo"
                            className="project item col-md-6 col-xl-4 workshop"
                        >
                            <figure className="lift rounded mb-6 border">
                                <Link to="/products/fabtech">
                                    <img src={fab} alt=""/>
                                </Link>
                            </figure>
                            <div className="project-details d-flex justify-content-center flex-column">
                                <div className="post-header">
                                    <div className="post-category mb-2 text-blue">
                                        Fab Tech
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            key={2}
                            data-sal="flip-up"
                            data-sal-delay="200"
                            data-sal-easing="easeInExpo"
                            className="project item col-md-6 col-xl-4 workshop"
                        >
                            <figure className="lift rounded mb-6 border">
                                <Link to="/products/medtech">
                                    <img src={med} alt=""/>
                                </Link>
                            </figure>
                            <div className="project-details d-flex justify-content-center flex-column">
                                <div className="post-header">
                                    <div className="post-category mb-2 text-yellow">
                                        Med Tech
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            key={3}
                            data-sal="flip-up"
                            data-sal-delay="300"
                            data-sal-easing="easeInExpo"
                            className="project item col-md-6 col-xl-4 workshop"
                        >
                            <figure className="lift rounded mb-6 border">
                                <Link to="/products/safetech">
                                    <img src={safe} alt=""/>
                                </Link>
                            </figure>
                            <div className="project-details d-flex justify-content-center flex-column">
                                <div className="post-header">
                                    <div className="post-category mb-2 text-red">
                                        Safe Tech
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            key={4}
                            data-sal="flip-up"
                            data-sal-delay="400"
                            data-sal-easing="easeInExpo"
                            className="project item col-md-6 col-xl-4 workshop"
                        >
                            <figure className="lift rounded mb-6 border">
                                <Link to="/products/agritech">
                                    <img src={agri} alt=""/>
                                </Link>
                            </figure>
                            <div className="project-details d-flex justify-content-center flex-column">
                                <div className="post-header">
                                    <div className="post-category mb-2 text-orange">
                                        Agri Tech
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            key={5}
                            data-sal="flip-up"
                            data-sal-delay="500"
                            data-sal-easing="easeInExpo"
                            className="project item col-md-6 col-xl-4 workshop"
                        >
                            <figure className="lift rounded mb-6 border">
                                <Link to="/products/packtech">
                                    <img src={pack} alt=""/>
                                </Link>
                            </figure>
                            <div className="project-details d-flex justify-content-center flex-column">
                                <div className="post-header">
                                    <div className="post-category mb-2 text-leaf">
                                        Pack Tech
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            key={6}
                            data-sal="flip-up"
                            data-sal-delay="600"
                            data-sal-easing="easeInExpo"
                            className="project item col-md-6 col-xl-4 workshop"
                        >
                            <figure className="lift rounded mb-6 border">
                                <Link to="/products/hospitality">
                                    <img src={hospitality} alt=""/>
                                </Link>
                            </figure>
                            <div className="project-details d-flex justify-content-center flex-column">
                                <div className="post-header">
                                    <div className="post-category mb-2 text-aqua">
                                        Hospitality
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Ready